import React from "react";
import { useState, useEffect } from "react";
// react-bootstrap components
import {
  Modal,
  Button
} from "react-bootstrap";
import { Auth } from "aws-amplify";
import PhoneInput from 'react-phone-input-2'
import { signOutUser, setUserVault } from 'services/Helper';
import rawCountries from './rawCountries';
import 'react-phone-input-2/lib/style.css'
import "../assets/css/style.css";
import "../assets/vendors/ti-icons/css/themify-icons.css";
import "../assets/vendors/base/vendor.bundle.base.css";
import CirclesLoader from "../layouts/CirclesLoader";

function UserProfile() {
  const [showModal, setShowModal] = React.useState(false);
  const [showModalMsg, setShowModalMsg] = React.useState("");
  let [firstName, setFirstName] = useState("");
  let [lastName, setLastName] = useState("");
  let [email, setEmail] = useState("");
  let [company, setCompany] = useState("");
  let [phoneNumber, setPhoneNumber] = useState("");
  let [originalPhoneNumber, setOriginalPhoneNumber] = useState("");
  let [country, setCountry] = useState("United Kingdom");
  const [canEditPhone, setCanEditPhone] = useState(false);
  const [isLoading, setLoading] = useState(false);
  //const history = useHistory();

  function normalizePhoneNumber(value) {
    const digits = `${value || ""}`.replace(/\D/g, "");
    return digits ? `+${digits}` : "";
  }

  async function populateUserProfile() {
    Auth.currentAuthenticatedUser({
      bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    }).then(user => {
      const groups = user.signInUserSession.idToken.payload["cognito:groups"] || [];
      setEmail(user.attributes.email);
      setFirstName(user.attributes.given_name);
      setLastName(user.attributes.family_name);
      setCompany(user.attributes["custom:company"]);
      setPhoneNumber(user.attributes.phone_number);
      setOriginalPhoneNumber(user.attributes.phone_number);
      setCountry(user.attributes["custom:country"]);
      setCanEditPhone(groups.includes("MEA_CORPORATE") || groups.includes("MEA_ADMIN"));
    }).catch(err => {
      if (err === "The user is not authenticated") {
        signOutUser();
      }
    });
  }

  async function savePhoneNumber(event) {
    event.preventDefault();
    if (!canEditPhone) return;
    const normalizedPhoneNumber = normalizePhoneNumber(phoneNumber);
    if (!normalizedPhoneNumber) {
      setShowModalMsg("Enter a valid phone number");
      setShowModal(true);
      return;
    }

    setLoading(true);
    try {
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
      const groups = user.signInUserSession.idToken.payload["cognito:groups"] || [];
      await Auth.updateUserAttributes(user, {
        phone_number: normalizedPhoneNumber,
      });
      await setUserVault(
        undefined,
        user.attributes.given_name,
        user.attributes.family_name,
        normalizedPhoneNumber,
        user.attributes["custom:company"],
        user.attributes["custom:country"],
        groups.join(","),
        user.attributes.sub
      );
      setPhoneNumber(normalizedPhoneNumber);
      setOriginalPhoneNumber(normalizedPhoneNumber);
      setShowModalMsg("Phone number updated successfully");
      setShowModal(true);
    } catch (err) {
      if (err === "The user is not authenticated") {
        signOutUser();
        return;
      }
      setShowModalMsg(err?.message || "Unable to update phone number");
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    populateUserProfile();
  }, []);

  return (
    <>
      <div className="row mx-0">
        <div className="col-12 grid-margin stretch-card user-profile">
          <div className="card">
            <div className="card-body">
              <p className="card-title">Edit</p>
              <div className="row">
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="form-group">
                    <label>Email</label>
                    <div className="input-group">
                      <input id="profileEmailInput" type="email" className="form-control form-control-lg" placeholder="Email" value={email} disabled onChange={(event) => { setEmail(event.target.value); }} />
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="form-group">
                    <label>Company</label>
                    <input id="profileCompanyInput" type="text" className="form-control form-control-lg" placeholder="Company" value={company} disabled onChange={(event) => { setCompany(event.target.value); }} />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="form-group">
                    <label>First Name</label>
                    <div className="input-group">
                      <input id="profileFirstNameInput" type="text" className="form-control form-control-lg" placeholder="First Name" value={firstName} disabled onChange={(event) => { setFirstName(event.target.value); }} />
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="form-group">
                    <label>Last Name</label>
                    <div className="input-group">
                      <input id="profileLastNameInput" type="text" className="form-control form-control-lg" placeholder="Last Name" value={lastName} disabled onChange={(event) => { setLastName(event.target.value); }} />
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-12 ph-num">
                  <div className="form-group">
                    <label>Phone Number</label>
                    <PhoneInput
                      country='gb'
                      disabled={!canEditPhone}
                      dropdownclassName=''
                      inputProps={{
                        id: "profilePhoneNumberInput",
                        name: "phoneNumber",
                        "aria-label": "Phone Number",
                      }}
                      preferredCountries={['gb', 'us', 'in']}
                      preserveOrder={['preferredCountries']}
                      value={phoneNumber}
                      onChange={(phNumber) => {
                        setPhoneNumber(phNumber);
                      }}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-12 country-dd">
                  <div className="form-group">
                    <label>Country</label>
                    <select className="form-control form-control-lg" disabled id="profileCountrySelect" value={country} onChange={(event) => {
                      let country = event.target.value;
                      setCountry(country);
                    }}>
                      {
                        rawCountries.map(country => (
                          <option key={country[0]}>{country[0]}</option>
                        ))
                      }
                    </select>
                  </div>
                </div>
              </div>
              {canEditPhone && (
                <div className="d-flex justify-content-center mt-3">
                  <button
                    type="button"
                    id="profileSavePhoneBtn"
                    className="btn btn-primary btn-md font-weight-medium"
                    disabled={
                      isLoading ||
                      normalizePhoneNumber(phoneNumber) === normalizePhoneNumber(originalPhoneNumber)
                    }
                    onClick={savePhoneNumber}
                  >
                    Save Phone Number
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Mini Modal */}
      <Modal
        className="modal-mini modal-primary"
        show={showModal}
        onHide={() => setShowModal(false)}
        animation={false}
        centered={true}
      >
        <Modal.Header className="justify-content-center">
          <div className="modal-profile">
            <i className="nc-icon nc-bulb-63"></i>
          </div>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p>{showModalMsg}</p>
        </Modal.Body>
        <div className="modal-footer justify-content-center">
          <Button
            className="btn-simple"
            type="button"
            variant="link"
            onClick={() => setShowModal(false)}
          >
            Close
          </Button>
        </div>
      </Modal>
      {/* End Modal */}
      {/* Mini Modal */}
      <Modal
            className="modal-centre new-modal"
            backdrop="static"
            keyboard={false}
            show={isLoading}
            animation={false}
            centered={true}
          >
            <Modal.Body className="text-center">
              <CirclesLoader isLoading={isLoading} />
            </Modal.Body>
          </Modal>
          {/* End Modal */}
    </>
  );
}

export default UserProfile;
